import "./auth.scss";
import { Form } from "react-bootstrap";
import InputForm from "../command/input/inputField";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Button from "../command/Button/Button";
import AuthMainTitle from "../command/authMainTitle/authMainTitle";
import OtpFormModal from "./otpFormModal";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { userClient } from "../../data/user";
import { useTranslation } from "react-i18next";
import { Effect } from "../../assets/svgIcon/customIcon";
import {
  AUTH_CRED,
  deleteCookie,
  getAuthCredentials,
  getIdvBypass,
  setAuthCredentials,
} from "../../utils/auth-utils";
import { useAuth } from "../../contexts/authContext";
import { jwtDecode } from "jwt-decode";
import { productDetailsClient } from "../../data/product-details";
import { Edit, Edit3 } from "react-feather";
import { toast } from "react-toastify";
import { formatCountryCodeWithPhoneNumber, formatPhoneNumber, isInternationalCountryCode } from "../../utils/utils";
import CountrySelectCode from "../command/countrySelect/countrySelect";

const SignupForm = () => {
  const { t } = useTranslation();
  const { toLogin } = useLocation()?.state || {};
  const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const phoneRegExp =
    /^\+?((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const registrationFormSchema = yup
    .object()
    .shape({
      countryNameCode: yup.string().optional(),
      countryCode: yup.string().required("Country code is required"),
      mobileNumber: yup
        .string()
        .required("Contact number is required")
        .matches(/^\d+$/, "Number must contain only digits")
        .min(8, "Contact number must be at least 8 characters"),
      password: yup
        .string()
        .required("Password is required")
        .matches(passwordRules, {
          message: "Please create a stronger password.",
        }),
      passwordConfirmation: yup
        .string()
        .oneOf([yup.ref("password")], "Password does not match.")
        .required("Confirmation password is required"),
    })
    .test(
      "combined-mobile-length",
      "Combined contact number (country code + mobile) must be at most 15 digits.",
      function (values) {
        if (!values.countryCode || !values.mobileNumber) {
          return true; // Skip if either is missing
        }
        const countryCodeDigits = values.countryCode.replace(/\D/g, "");
        const mobileDigits = values.mobileNumber.replace(/\D/g, "");
        const combinedLength = countryCodeDigits.length + mobileDigits.length;

        if (combinedLength > 15) {
          // Attach the error to the mobileNumber field:
          return this.createError({
            path: "mobileNumber",
            message:
              "Combined contact number (country code + mobile) must be at most 15 digits.",
          });
        }

        return true;
      }
    );

  const [otpModalShow, setOtpModalShow] = useState(false);
  const navigate = useNavigate();
  const methods = useForm({
    resolver: yupResolver(registrationFormSchema),
    mode: "all",
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, touchedFields, isSubmitted },
    getValues,
    watch,
    resetField,
    setValue,
    trigger
  } = methods;

  const [mobileValue, setMobileValue] = useState(false);
  const [token, setToken] = useState("");
  const [idvBypass, setIdvBypass] = useState(false);
  const [quote, setQuote] = useState<any>();
  const [emailStore] = useState(localStorage.getItem("email"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const numberPhone = watch("mobileNumber");
  const countryCodeValue = watch("countryCode");

  const [isInternationalCode, setIsInternationalCode] = useState<boolean>(false);

  const [emailValue, setEmailValue] = useState<string>(emailStore || '');


  const handleValueChange = (newValue: boolean) => {
    setMobileValue(newValue);
  };

  const [countryCode, setCountryCode] = useState("+44");
  const [countryNameCode, setCountryNameCode] = useState("GB");
  const { bypassIDV, maximumOrderValue, disableIDV } = getIdvBypass();
  const { customerUuid, quoteId } = getAuthCredentials();
  const { login, signUpEmail } = useAuth();
  const customerQuteUpdate = (customerid: string) => {
    const value = {
      customerQuoteUuid: quoteId,
      customerUuid: customerid,
    };
    productDetailsClient
      .updateCustomerQuote(value)
      .then((data: any) => { })
      .catch((error: any) => {
        toast.error(error?.message);
      });
  };


  useEffect(() => {
    if (quoteId) {
      productDetailsClient
        .getProductDetailsList({ quoteUuid: quoteId })
        .then((data: any) => {
          setQuote(data.quote);

          if (bypassIDV) {
            const idvBypass = Number(data.quote?.productRetailPrice) <= Number(maximumOrderValue ?? 0);
            setIdvBypass(idvBypass)
          }

        })
        .catch((error: any) => {
          toast.error(error?.message);
        });
    }
  }, [bypassIDV, maximumOrderValue]);

  const handleBypassRegistration = async () => {
    const formattedNumber = formatCountryCodeWithPhoneNumber(getValues("countryCode"), getValues("mobileNumber"));
const isInternational = isInternationalCountryCode(getValues("countryCode") || '');
    const value = {
      email: emailStore != null ? emailStore : "",
      password: "",
      phone: formattedNumber,
      userTypeId: 6,
      customerQuoteUuid: quoteId,
      isInternational,
    };

    userClient
      .registerCustomer(value)
      .then((response: any) => {
        if (response.success) {
          const decodedToken: any = jwtDecode(response.data.access_token);
          const customerUuid = decodedToken?.uuid;
          const userUuid = decodedToken?.userUuid;
          const countryCode = decodedToken?.countryCode;
          const isInternational = decodedToken?.isInternational;
          deleteCookie(AUTH_CRED);
          setAuthCredentials(
            response.data.access_token,
            response.data.refresh_token,
            customerUuid,
            userUuid,
            null,
            countryCode,
            isInternational
          );
          login();
          // customerQuteUpdate(userUuid);
          toast.success("Customer Register Successfully");
          navigate("/information-capture");
        } else {
          toast.error(response.error);
        }
      })
      .catch((error: any) => {
        toast.error(error?.message);
      });
  };

  const handleByPassLogin = async () => {
    const formattedNumber = formatCountryCodeWithPhoneNumber(getValues("countryCode"), getValues("mobileNumber"));

    const value = {
      email: emailStore != null ? emailStore : "",
      password: "",
      userTypeId: 6,
      phone: formattedNumber,
      customerQuoteUuid: quoteId
    };
    
    // Call the handleFinalSubmit function with the required parameters
    try {
      setLoading(true);
      setError("");
      const request = {
        username: value.email,
        password: value.password,
        userTypeId: value.userTypeId,
        phoneNumber: value.phone,
        customerQuoteUuid: value.customerQuoteUuid,
      };
      
      const res = await userClient.initiateLogin(request);
      if (res.success) {
        const decodedToken: any = jwtDecode(res.data.access_token);
        deleteCookie(AUTH_CRED);
        if (decodedToken) {
          const customerUuid = decodedToken?.uuid;
          const userUuid = decodedToken?.userUuid;
          const countryCode = decodedToken?.countryCode;
          const isInternational = decodedToken?.isInternational;

          setAuthCredentials(
            res.data.access_token,
            res.data.refresh_token,
            customerUuid,
            userUuid,
            null,
            countryCode,
            isInternational
          );
          login();
          console.log("decodedToken isKYCVerified :: ", decodedToken);
          // await customerQuteUpdate(userUuid);

          if (disableIDV || decodedToken?.isKYCVerified) {
            navigate("/information-capture");
          } else {
            navigate("/verify-identity");
          }
        } else {
          console.log("Customer Uuid not set");
        }
      } else {
        toast.error(res.error);
      }
    } catch (error: any) {
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  }

  const onSubmit = async (values: any) => {
    const formattedNumber = formatCountryCodeWithPhoneNumber(values.countryCode, values.mobileNumber);
    const isInternational = isInternationalCountryCode(values.countryCode);

    setIsInternationalCode(isInternational);

    const value = {
      email: emailStore != null ? emailStore : "",
      password: values.password,
      phone: formattedNumber,
      customerType: 1,
      userTypeId: 1,
      countryCode: values.countryCode,
      countryNameCode: values.countryNameCode,
      isInternational,
      customerQuoteUuid: quoteId,
    };
    userClient
      .registerCustomer(value)
      .then((response: any) => {
        if (response.success) {
          const decodedToken: any = jwtDecode(response.data.access_token);
          const customerUuid = decodedToken?.uuid;
          const userUuid = decodedToken?.userUuid;
          const countryCode = decodedToken?.countryCode;
          const isInternational = decodedToken?.isInternational;
          deleteCookie(AUTH_CRED);
          setAuthCredentials(
            response.data.access_token,
            response.data.refresh_token,
            customerUuid,
            userUuid,
            null,
            countryCode,
            isInternational
          );
          toast.success("Customer Register Sucessfully");
          login();
          // customerQuteUpdate(userUuid);

          const disableIDV = getIdvBypass().disableIDV;

          if (disableIDV) {
            navigate("/information-capture");
          } else {
            navigate("/verify-identity");
          }
        } else {
          toast.error(response.error);
        }
      })
      .catch((error: any) => {
        toast.error(error?.message);
      });
  };

  const sendOtp = async () => {
    const contact = getValues("mobileNumber");
    const formattedNumber = formatCountryCodeWithPhoneNumber(getValues("countryCode"), contact);
    const email = localStorage.getItem("email") || signUpEmail || '';
    const isInternational = isInternationalCountryCode(getValues('countryCode'));

    setIsInternationalCode(isInternational);

    setEmailValue(email)

    const number = {
      phoneNumber: formattedNumber,
      isInternational,
      email
    };
    userClient
      .sendOtp(number)
      .then((res: any) => {
        if (res?.status === "ok") {
          setToken(res.token);
          setOtpModalShow(true);
          toast.success(`${t("sent-verification-code")} ${formattedNumber}${isInternational ? ` and ${email}` : ''}`);
        } else {
          toast.error(res?.error);
        }
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (numberPhone) {
      trigger("mobileNumber");
    }
  }, [countryCodeValue, numberPhone]);


  useEffect(() => setValue("countryCode", "+44"), []);

  const changePhoneValue = () => {
    setMobileValue(false);
    resetField("mobileNumber");
    setCountryCode("+44");
  };

  return (
    <>
      <div className="login-form-section signup-form-section">
        <div className="effect-add-section auth-page-effect">
          <Effect className="effect-img" />
          <AuthMainTitle
            mainTitleText={t("activate-your-account")}
            className="login-title"
          />
          <div className="user-email-box">
            <h3 className="user-email">{emailStore}</h3>
            <Link to={`/login`} className="edit-link">
              {t("edit")}
            </Link>
          </div>
          <FormProvider {...methods}>
            <Form>
              <div className="mobile-input-box">
                <CountrySelectCode
                  codeClassName="country-code position-relative"
                  disabled={mobileValue}
                  onChange={(params: { label: string; countryNameCode: string }) => {
                    console.log(params)
                    setCountryCode(params.label);
                    setCountryNameCode(params.countryNameCode);
                  }}
                />
                <input type="hidden" {...register("countryCode")} />
                <input type="hidden" {...register("countryNameCode")} />

                <InputForm
                  inputId="mobile-number"
                  inputLable={t("input-label-contact")}
                  inputType="text"
                  required
                  inputPlaceholder={t("input-label-contact")}
                  register={register("mobileNumber")}
                  error={errors?.mobileNumber?.message}
                  inputChecked={mobileValue}
                  inputClassName="mobile-number"
                  disabled={mobileValue}
                />
                {mobileValue && (
                  <Link
                    to={""}
                    onClick={changePhoneValue}
                    className="number-edit"
                  >
                    <Edit3 />
                  </Link>
                )}
                {!idvBypass && !disableIDV &&
                  !mobileValue && (
                    <Link
                      onClick={sendOtp}
                      className={`${!(numberPhone && !errors.mobileNumber && !mobileValue)
                        ? "disable"
                        : ""
                        } varify-btn`}
                      to={"#"}
                    >
                      {t("verify")}
                    </Link>
                  )}
              </div>
              {mobileValue && (
                <>
                  <InputForm
                    inputId="login-password"
                    inputLable={t("input-label-password")}
                    inputType="password"
                    required
                    inputPlaceholder={t("input-label-password")}
                    register={register("password")}
                    error={errors?.password?.message}
                  />
                  <InputForm
                    inputId="login-confirm-password"
                    inputLable={t("input-label-confirm-password")}
                    inputType="password"
                    required
                    inputPlaceholder={t("input-label-confirm-password")}
                    register={register("passwordConfirmation")}
                    error={errors?.passwordConfirmation?.message}
                  />
                </>
              )}
            </Form>
          </FormProvider>
          {mobileValue && <p className="password-note">{t("password-note")}</p>}
          <div className="form-btn-section">
            <Button
              btnText={t("continue")}
              disabled={!numberPhone || !!errors.mobileNumber || (!(idvBypass || disableIDV) && !mobileValue)}
              onClick={(idvBypass || disableIDV) ? (toLogin ? handleByPassLogin : handleBypassRegistration) : handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>

      <OtpFormModal
        show={otpModalShow}
        number={`${getValues("mobileNumber")}`}
        token={token}
        countryCode={`${getValues("countryCode")}`}
        isInternational={isInternationalCode}
        email={emailValue}
        onHide={() => setOtpModalShow(false)}
        onValueChange={handleValueChange}
      />
    </>
  );
};

export default SignupForm;
